const isReactNativeModule = ({ source, specifiers }) =>
  source &&
  (source.value === 'react-native' || source.value === 'react-native-web') &&
  specifiers.length;

const hasPlatformImport = ({ specifiers }, t) => {
  return specifiers.some(s => t.isImportSpecifier(s) && s.imported.name === 'Platform');
};

module.exports = ({ types: t }) => ({
  name: 'babel-plugin-pulsar-ui',
  visitor: {
    ImportDeclaration: path => {
      const { specifiers } = path.node;
      if (isReactNativeModule(path.node) && hasPlatformImport(path.node, t)) {
        const imports = specifiers.filter(specifier => {
          return !(t.isImportSpecifier(specifier) && specifier.imported.name === 'Platform');
        });

        const platformImport = specifiers.find(
          s => t.isImportSpecifier(s) && s.imported.name === 'Platform'
        );

        path.replaceWithMultiple([
          t.importDeclaration(imports, t.stringLiteral(path.node.source.value)),
          t.importDeclaration(
            [t.importDefaultSpecifier(t.identifier(platformImport.local.name))],
            t.stringLiteral('src/libs/platform/Platform')
          ),
        ]);
      }
    },
  },
});
